<template>
  <div class="binding-mobile">
    <van-field
      v-model.trim="mobile"
      type="tel"
      label="手机号码"
      maxlength="11"
      class="tel-number flex-center"
      clearable
      placeholder="请输入手机号码"
      @blur="mobileValidator(mobile)"
      @input="init"
    />
    <van-field
      v-model.trim="code"
      center
      label="验 证 码"
      :maxlength="4"
      class="tel-number flex-center label-color"
      :disabled="!mobileValid"
      clearable
      placeholder="请输入验证码"
    >
      <van-button
        @click="getCode"
        slot="button"
        :color="$util.isMobileValid(mobile) ? '#1E8DFF' : '#F7F7F7'"
        size="small"
        class="get-code"
        :disabled="!$util.isMobileValid(mobile)"
        v-if="!timer || !$util.isMobileValid(mobile)"
      >
        <div :class="!$util.isMobileValid(mobile) && 'get-code-btn'">
          <span v-if="sendTime <= 1">获取验证码</span>
          <span v-else>再次发送</span>
        </div>
      </van-button>
      <van-button slot="button" color="#F7F7F7" size="small" disabled style="width: 78px" v-else>
        <span class="color999">{{ seconds }}s</span>
      </van-button>
    </van-field>

    <div class="checkbox" v-if="showChecked">
      <van-checkbox icon-size="16" v-model="checked"><span>已同意并阅读</span></van-checkbox>
      <span class="link-btn" @click="processLink2">《用户服务协议》</span>
      <span>和</span>
      <span class="link-btn" @click="processLink">《隐私权政策》</span>
      
    </div>
  </div>
</template>

<script>
import mobileValidator from '@/mixins/mobileValidator';
export default {
  name: 'BindingMobile',
  mixins: [mobileValidator],
  props: {
    telInput: {
      default: {}
    },
    verifyCodeType: {
      default: 'BIND_PATIENT_MOBILE'
    },
    showChecked: {
      default: false
    }
  },
  data() {
    return {
      mobile: this.telInput.mobile,
      code: this.telInput.code,
      seconds: 60,
      timer: '',
      sendTime: 1,
      checked: false
    };
  },
  watch: {
    mobile(newVal) {
      this.$emit('inputTelInfo', { type: 'mobile', value: newVal });
    },
    code(newVal) {
      this.$emit('inputTelInfo', { type: 'code', value: newVal });
    }
  },
  created() {},
  beforeDestroy() {
    this.clearTimer();
  },

  methods: {
    init() {
      this.clearTimer();
      this.sendTime = 1;
      this.code = '';
    },
    getCode() {
      const params = {
        mobile: this.mobile,
        verifyCodeType: this.verifyCodeType
      };
      this.$fetch.getMobileCode(params).then(() => {
        this.$toast('验证码已发送');
        this.countdown();
        this.sendTime++;
      });
    },
    countdown() {
      this.timer = setInterval(() => {
        this.seconds--;
        if (this.seconds < 0) {
          this.timer = this.clearTimer();
          this.seconds = 60;
          return;
        }
        console.log(this.timer);
      }, 1000);
    },
    clearTimer() {
      this.timer = clearInterval(this.timer);
    },
    processLink() {
      window.location.href = 'https://static.91jkys.com/kaer/zyydysxy/index.html#/';
    },
    processLink2() {
      window.location.href ='https://static.91jkys.com/kaer/ydyhfwxy/index.html#/'
    }
  }
};
</script>
<style scoped lang="scss">
.binding-mobile {
  .flex-center {
    ::v-deep .van-cell__flexrow {
      .van-cell__flexbox {
        width: 100%;
        align-items: center;
      }
    }
  }
  .tel-number {
    input::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #ccc;
    }

    input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #ccc;
    }

    input:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #ccc;
    }
  }
  .label-color {
    ::v-deep .van-cell__flexrow {
      .van-field__label {
        color: #707070;
      }
    }
  }
  .get-code-btn {
    color: #999999;
  }
  .get-code {
    background: #f7f7f7;
  }

  .checkbox {
    display: flex;
    margin-top: 16px;
    padding: 0 16px;
    flex-direction: row;
    align-items: center;
    span {
      font-size: 14px;
      line-height: 1;
      color: #262626;
      &.link-btn {
        color: #1e8dff;
      }
    }
  }
}
</style>
